import type { BrandingStatus } from '@domain/schemas/branding.schema';
import type { DbSubmissionStatus, DbTemplateStatus } from '@domain/schemas/contract.schema';
import { ResourceState } from '@domain/schemas/contract.schema';
import type { DocumentOperation } from '@helpers/document-mode';
import { DocumentMode } from '@helpers/document-mode';

type DocumentStatuses = {
  [DocumentMode.SUBMISSIONS]: DbSubmissionStatus[];
  [DocumentMode.ENDORSEMENTS]: DbSubmissionStatus[];
  [DocumentMode.TEMPLATES]: DbTemplateStatus[];
  [DocumentMode.BRANDING]: BrandingStatus[];
};

// Defines which document statuses allow which operations in each document mode
const OPERATIONS_ALLOWED_IN_DOC_STATUS: Record<DocumentOperation, DocumentStatuses> = {
  edit: {
    [DocumentMode.SUBMISSIONS]: [ResourceState.DRAFT],
    [DocumentMode.ENDORSEMENTS]: [ResourceState.DRAFT],
    [DocumentMode.TEMPLATES]: [ResourceState.DRAFT],
    [DocumentMode.BRANDING]: [ResourceState.DRAFT],
  },
  'status-change': {
    [DocumentMode.SUBMISSIONS]: [
      ResourceState.DRAFT,
      ResourceState.ARCHIVED,
      ResourceState.REVIEW,
      ResourceState.FIRM_ORDER,
    ],
    [DocumentMode.ENDORSEMENTS]: [ResourceState.DRAFT, ResourceState.REVIEW, ResourceState.ARCHIVED],
    [DocumentMode.TEMPLATES]: [
      ResourceState.DRAFT,
      ResourceState.REVIEW,
      ResourceState.PUBLISHED,
      ResourceState.ARCHIVED,
    ],
    [DocumentMode.BRANDING]: [ResourceState.DRAFT, ResourceState.PUBLISHED, ResourceState.ARCHIVED],
  },
};

export default OPERATIONS_ALLOWED_IN_DOC_STATUS;
